export default {
    namespaced: true,
    state: {
        // 判断Ajax是否完成
        incomeAjaxComplete: false,// false-未完成、true-完成
        // 收益积分数据
        incomePointInfo: {
            incomePoint: '100',// 收益积分
            bookingNumber: '0',// 订舱票数
            takeOffNumber: '0',// 出货票数
            incomeRate: '100',// 收益率
        },
    },
    mutations: {
        // 判断Ajax是否完成
        incomeAjaxComplete(state, value) {
            state.incomeAjaxComplete = value;
        },
        // 修改收益积分数据
        incomePointInfo(state, value) {
            state.incomePointInfo = value;
        }
    }
};